// extracted by mini-css-extract-plugin
export default {"searchInput":"h8JZ6p75cIfeRmnbYCKA"};